/**
 * src/pages/Index.tsx — the `/` route: the converter, behind the auth gate.
 *
 * Source: `D:/WCS/latex2html-french-trad/src/pages/Index.tsx` (whole file, 13 lines).
 * Spec:   `docs/spec/06-frontend-components.md` §1.3 (route table), §1.4 (gating semantics).
 *
 * Two lines of substance, and both matter:
 *
 *  - `ProtectedRoute` renders `<HexclaveAuthForm/>` **in place** when logged out — it does not `<Navigate>`,
 *    so the URL stays `/` through the whole login flow (spec §1.4.2). Do not swap it for a redirect.
 *  - `<ConverterApp/>` is mounted **inside** the gate, so its state (`preamble`, `docContent`, the
 *    two loaded names) is created only after authentication and is destroyed on logout. That
 *    unmount is silent and unguarded — DF-22 rank 1: there is no `beforeunload`, no dirty flag and
 *    no draft, so logging out with unsaved edits in either editor tab loses them with no prompt.
 *    Reproduced by construction; do not add a guard here.
 *
 * `/admin` is deliberately NOT wrapped this way (`App.tsx:22`) — it gates itself and redirects
 * (`Admin.tsx:18-20`), which is why the login form never appears at `/admin` (spec §1.4).
 */
import { ConverterApp } from '@/components/ConverterApp'
import { ProtectedRoute } from '@/components/ProtectedRoute'

const Index = () => {
  return (
    <ProtectedRoute>
      <ConverterApp />
    </ProtectedRoute>
  )
}

export default Index
